export const currencySign = {
  USD: "$",
  GBP: "£",
  CNY: "¥",
  KRW: "₩",
  EUR: "€",
  THB: "฿",
  SVC: "₡",
  GHS: "₵",
  VND: "₫",
  INR: "₹",
  AUD: "AUD",
  CAD: "CAD",
  AWG: "ƒ",
  HKD: "HK$",
  JPY: "JPY",
  TWD: "TWD",
  NZD: "NZD",
  ZAR: "ZAR",
  SGD: "SGD",
  AFN: "AFN",
  ALL: "ALL",
  DZD: "DZD",
  AOA: "AOA",
  XCD: "XCD",
  ARS: "ARS",
  AMD: "AMD",
  AZN: "AZN",
  BSD: "BSD",
  BHD: "BHD",
  BDT: "BDT",
  BBD: "BBD",
  BYN: "BYN",
  BZD: "BZD",
  XOF: "XOF",
  BMD: "BMD",
  BTN: "BTN",
  BOB: "BOB",
  BOV: "BOV",
  BAM: "BAM",
  BWP: "BWP",
  NOK: "NOK",
  BRL: "BRL",
  BND: "BND",
  BGN: "BGN",
  BIF: "BIF",
  CVE: "CVE",
  KHR: "KHR",
  XAF: "XAF",
  KYD: "KYD",
  CLP: "CLP",
  CLF: "CLF",
  COP: "COP",
  COU: "COU",
  KMF: "KMF",
  CDF: "CDF",
  CRC: "CRC",
  HRK: "HRK",
  CUP: "CUP",
  CUC: "CUC",
  ANG: "ANG",
  CZK: "CZK",
  DKK: "DKK",
  DJF: "DJF",
  DOP: "DOP",
  EGP: "EGP",
  ERN: "ERN",
  SZL: "SZL",
  ETB: "ETB",
  FKP: "FKP",
  FJD: "FJD",
  XPF: "XPF",
  GMD: "GMD",
  GEL: "GEL",
  GIP: "GIP",
  GTQ: "GTQ",
  GNF: "GNF",
  GYD: "GYD",
  HTG: "HTG",
  HNL: "HNL",
  HUF: "HUF",
  ISK: "ISK",
  IDR: "IDR",
  XDR: "XDR",
  IRR: "IRR",
  IQD: "IQD",
  ILS: "ILS",
  JMD: "JMD",
  JOD: "JOD",
  KZT: "KZT",
  KES: "KES",
  KPW: "KPW",
  KWD: "KWD",
  KGS: "KGS",
  LAK: "LAK",
  LBP: "LBP",
  LSL: "LSL",
  LRD: "LRD",
  LYD: "LYD",
  CHF: "CHF",
  MOP: "MOP",
  MKD: "MKD",
  MGA: "MGA",
  MWK: "MWK",
  MYR: "MYR",
  MVR: "MVR",
  MRU: "MRU",
  MUR: "MUR",
  XUA: "XUA",
  MXN: "MXN",
  MXV: "MXV",
  MDL: "MDL",
  MNT: "MNT",
  MAD: "MAD",
  MZN: "MZN",
  MMK: "MMK",
  NAD: "NAD",
  NPR: "NPR",
  NIO: "NIO",
  NGN: "NGN",
  OMR: "OMR",
  PKR: "PKR",
  PAB: "PAB",
  PGK: "PGK",
  PYG: "PYG",
  PEN: "PEN",
  PHP: "PHP",
  PLN: "PLN",
  QAR: "QAR",
  RON: "RON",
  RUB: "RUB",
  RWF: "RWF",
  SHP: "SHP",
  WST: "WST",
  STN: "STN",
  SAR: "SAR",
  RSD: "RSD",
  SCR: "SCR",
  SLL: "SLL",
  SLE: "SLE",
  XSU: "XSU",
  SBD: "SBD",
  SOS: "SOS",
  SSP: "SSP",
  LKR: "LKR",
  SDG: "SDG",
  SRD: "SRD",
  SEK: "SEK",
  CHE: "CHE",
  CHW: "CHW",
  SYP: "SYP",
  TJS: "TJS",
  TZS: "TZS",
  TOP: "TOP",
  TTD: "TTD",
  TND: "TND",
  TRY: "TRY",
  TMT: "TMT",
  UGX: "UGX",
  UAH: "UAH",
  AED: "AED",
  USN: "USN",
  UYU: "UYU",
  UYI: "UYI",
  UYW: "UYW",
  UZS: "UZS",
  VUV: "VUV",
  VES: "VES",
  VED: "VED",
  YER: "YER",
  ZMW: "ZMW",
  ZWL: "ZWL",
  XBA: "XBA",
  XBB: "XBB",
  XBC: "XBC",
  XBD: "XBD",
  XTS: "XTS",
  XXX: "XXX",
  XAU: "XAU",
  XPD: "XPD",
  XPT: "XPT",
  XAG: "XAG",
};
